module.exports = __webpack_public_path__ + "img/c04_buildingstartechcroprotation_Normal_ua.001fe00f.webp";